import { Component, OnInit } from '@angular/core';
import {IconBaseComponent} from '../base/icon-base.component';

@Component({
  selector: 'app-icon-archive',
  templateUrl: './icon-archive.component.html',
  styleUrls: ['./icon-archive.component.scss']
})
export class IconArchiveComponent extends IconBaseComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
